import { ArrowBackIos, ArrowForwardIos, Close } from '@material-ui/icons'
import React, { useState } from 'react'
import Modal from 'styled-react-modal'

import { closeModal, useModalState } from '../../../../../../lib/rewards/onboarding/modal'
import * as Styled from './styled'

import P5A from '../../../../../../img/rewards_onboarding/modal/bag-handle.png'
import P2B from '../../../../../../img/rewards_onboarding/modal/card.png'
import P2A from '../../../../../../img/rewards_onboarding/modal/cash.png'
import P3B from '../../../../../../img/rewards_onboarding/modal/content.png'
import P5B from '../../../../../../img/rewards_onboarding/modal/Frame 774.png'
import P4B from '../../../../../../img/rewards_onboarding/modal/Group 630.png'
import P1A from '../../../../../../img/rewards_onboarding/modal/p1a.png'
import P1B from '../../../../../../img/rewards_onboarding/modal/p1b.png'
import P3A from '../../../../../../img/rewards_onboarding/modal/ribbon.png'
import P4A from '../../../../../../img/rewards_onboarding/modal/usd.png'

type ArrowProps = {
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
  currentSlide: number
  slidesLength: number
  onContinue?: () => void | null
}

interface RewardsOnboardingModalProps {
  onContinue?: () => void | null
}

const SliderPrevArrow: React.FC<ArrowProps> = ({ className, style, onClick, currentSlide }) => {
  if (currentSlide === 0) {
    return null
  }

  return (
    <Styled.ArrowContainer
      className={className}
      onClick={onClick}
      style={style}
      hide={currentSlide === 0}
    >
      <ArrowBackIos htmlColor="black" viewBox="0 0 18 24" />
    </Styled.ArrowContainer>
  )
}
const SliderNextArrow: React.FC<ArrowProps> = ({
  className,
  style,
  onClick,
  currentSlide,
  slidesLength,
  onContinue,
}) => {
  if (currentSlide === 0) {
    return (
      <Styled.Button onClick={onClick}>
        Learn more <ArrowForwardIos />
      </Styled.Button>
    )
  }

  if (currentSlide === slidesLength - 1) {
    return <Styled.Button onClick={onContinue}>Got it</Styled.Button>
  }

  return (
    <Styled.ArrowContainer className={className} onClick={onClick} style={style}>
      <ArrowForwardIos htmlColor="white" viewBox="0 0 24 24" />
    </Styled.ArrowContainer>
  )
}

const slides = [
  <>
    <Styled.Header>Welcome to</Styled.Header>
    <Styled.Image src={P1A} width="278px" margin="0 auto 32px" />
    <Styled.Text>
      Keep track of your sales, rewards and benefits, while gaining access to practitioner-exclusive
      features.
    </Styled.Text>
    <Styled.ImageWrapper>
      <Styled.Image src={P1B} />
    </Styled.ImageWrapper>
  </>,
  <>
    <Styled.Logo src={P2A} />
    <Styled.SubHeader>Rewards and Discounts</Styled.SubHeader>
    <Styled.Text>
      Starting today, you can spend your rewards online giving you flexibility to exchange your
      award for products at any time.
    </Styled.Text>
    <Styled.ImageWrapper>
      <Styled.Image src={P2B} margin="18px auto 104px" width="90%" />
    </Styled.ImageWrapper>
  </>,
  <>
    <Styled.Logo src={P3A} />
    <Styled.SubHeader>Status and rewards</Styled.SubHeader>
    <Styled.Text>
      Awards status and balance are now visible through your renewed My Account page.
    </Styled.Text>
    <Styled.ImageWrapper>
      <Styled.Image src={P3B} margin="18px auto 104px" width="95%" />
    </Styled.ImageWrapper>
  </>,
  <>
    <Styled.Logo src={P4A} />
    <Styled.SubHeader>Cashing out</Styled.SubHeader>
    <Styled.Text>
      If you prefer to cash out, you can do it when over $200 account balance for Commissions, and
      $1000 for Rebates.
    </Styled.Text>
    <Styled.ImageWrapper>
      <Styled.Image src={P4B} margin="18px 0 104px" />
    </Styled.ImageWrapper>
  </>,
  <>
    <Styled.Logo src={P5A} />
    <Styled.SubHeader>Spend as you earn</Styled.SubHeader>
    <Styled.Text>Start spending today to earn more rewards.</Styled.Text>
    <Styled.ImageWrapper>
      <Styled.Image src={P5B} margin="18px 0 104px" position="-136px" width="600px" />
    </Styled.ImageWrapper>
  </>,
]

export const RewardsOnboardingModal: React.VFC<RewardsOnboardingModalProps> = ({ onContinue }) => {
  const { isOpen } = useModalState()
  const initialSlide = 0
  const [currentSlide, setCurrentSlide] = useState(initialSlide)

  const handleAfterChange = (currentIndex: number) => {
    setCurrentSlide(currentIndex)
  }

  const handleContinue = () => {
    if (!onContinue) {
      return
    }

    onContinue()
    closeModal()
  }

  return (
    <Modal isOpen={isOpen}>
      <Styled.Content currentSlide={currentSlide}>
        <Styled.CloseModal onClick={() => handleContinue()}>
          <Close />
        </Styled.CloseModal>
        <Styled.Slider
          afterChange={handleAfterChange}
          swipe
          dots={currentSlide !== 0}
          speed={500}
          infinite={false}
          initialSlide={initialSlide}
          prevArrow={<SliderPrevArrow currentSlide={currentSlide} slidesLength={slides.length} />}
          nextArrow={
            <SliderNextArrow
              currentSlide={currentSlide}
              slidesLength={slides.length}
              onContinue={onContinue}
            />
          }
          slidesToShow={1}
          slidesToScroll={1}
        >
          {slides.map((slide, index) => (
            <React.Fragment key={`slide-${index}`}>{slide}</React.Fragment>
          ))}
        </Styled.Slider>
      </Styled.Content>
    </Modal>
  )
}
